<section class="bg-surface-100 dark:bg-surface-950 px-0 lg:py-20 md:p-12 lg:px-20">
	<div class="px-6 py-8 md:p-14 bg-primary-500 dark:bg-surface-900 dark:border-surface-800 shadow-xl">
		<div class="grid grid-cols-1 lg:grid-cols-2 items-start gap-10 h-full">
			<div class="flex-1 flex flex-col h-full lg:max-w-lg gap-12">
				<div class="flex-1 flex flex-col gap-6 justify-center">
					@if (content.title.length > 0){
					<h1
						class="text-5xl leading-tight font-bold text-surface-0 dark:text-surface-0"
						[innerHTML]="content.title"></h1>
					} @if (content.description.length > 0){
					<h2
						class="text-xl leading-normal text-surface-0 dark:text-surface-400"
						[innerHTML]="content.description"></h2>
					}
				</div>
			</div>
			<div class="flex flex-col gap-6 h-full">
				<app-offer-form></app-offer-form>
			</div>
		</div>
	</div>
</section>
